module.exports = __webpack_public_path__ + "img/icon-hotel.55ee3da5.svg";